import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

export const RecordStatus = {
  Active: "active",
  Archived: "archived",
  All: "all",
};

const STATUS_OPTIONS = [
  { value: RecordStatus.Active, label: "Active" },
  { value: RecordStatus.Archived, label: "Archived" },
  { value: RecordStatus.All, label: "All" },
];

export function RecordStatusDropdown({
  className,
  selected = RecordStatus.Active,
  onChange,
  placeholder = "Status",
}) {
  const selectedOption = STATUS_OPTIONS.find((o) => o.value === selected);

  return (
    <Dropdown
      className={className}
      selected={selected}
      onOptionSelected={(value) => onChange?.(value ?? RecordStatus.Active)}
    >
      <DropdownButton placeholder={placeholder}>
        {selectedOption?.label}
      </DropdownButton>
      <DropdownItems>
        {STATUS_OPTIONS.map((option) => (
          <DropdownItem key={option.value} value={option.value}>
            {option.label}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
}
